var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var treatInfo = {
    'beef-blueberry-treats-7oz': {
        detailsList: [
            'Tender beef and nutritious blueberries',
            'A good source of fiber',
            'Chickpeas for plant-based protein',
            'Use for training or as a healthy snack',
        ],
        descriptionLong: "Featuring beef and blueberries carefully dehydrated to\n    preserve nutrients while maintaining crunch, they\u2019re an irresistible snack\n    you and your pup can both feel good about.",
        displayName: 'Beef & Blueberry Flavor',
        ingredients: 'Beef, Chickpeas, Cane Molasses, Blueberries, Salt, Rosemary',
        isNew: true,
        nutritionInfo: {
            caloriesPerUnit: 34,
            carbohydrateCalories: 5,
            carbohydrateGrams: 1.8,
            carbohydratePercent: 20,
            fatCalories: 18,
            fatGrams: 1.4,
            fatPercent: 15,
            fiberGrams: 0.9,
            fiberPercent: 10,
            gramsPerUnit: 9,
            moistureGrams: 2.1,
            moisturePercent: 23,
            proteinCalories: 11,
            proteinGrams: 2.7,
            proteinPercent: 30,
        },
        productType: 'treat',
        topSeller: false,
    },
    'beef-jerky-treats-4oz': {
        detailsList: [
            'Made from 100% beef',
            'No artificial colors, flavors, fillers or funky stuff',
            'Gently dehydrated for the chewy texture dogs love',
            'Easy to break into pieces for training, or to use as a meal topper',
        ],
        descriptionLong: "Made with 100% premium beef and nothing more, they're an\n    all-natural, protein-rich snack that you and your pup can both feel good\n    about. Available in 4 oz packages.",
        displayName: 'Beef Jerky',
        ingredients: 'Beef',
        isNew: false,
        nutritionInfo: {
            caloriesPerUnit: 80,
            carbohydrateCalories: 0,
            carbohydrateGrams: 0,
            carbohydratePercent: 0,
            fatCalories: 37,
            fatGrams: 3.2,
            fatPercent: 18,
            fiberGrams: 1.3,
            fiberPercent: 7,
            gramsPerUnit: 18,
            moistureGrams: 1.8,
            moisturePercent: 10,
            proteinCalories: 43,
            proteinGrams: 9.9,
            proteinPercent: 55,
        },
        productType: 'treat',
        topSeller: false,
    },
    'chicken-cranberry-treats-7oz': {
        detailsList: [
            'Tender chicken and nutritious cranberries',
            'A good source of fiber',
            'Chickpeas for plant-based protein',
            'Use for training or as a healthy snack',
        ],
        descriptionLong: "Featuring chicken and cranberries carefully dehydrated to\n    preserve nutrients while maintaining crunch, they\u2019re an irresistible snack\n    you and your pup can both feel good about.",
        displayName: 'Chicken & Cranberry Flavor',
        ingredients: 'Chicken, Cranberry, Vegetable Glycerin, Chickpeas, Salt',
        isNew: true,
        nutritionInfo: {
            caloriesPerUnit: 26,
            carbohydrateCalories: 3,
            carbohydrateGrams: 1.3,
            carbohydratePercent: 16,
            fatCalories: 11,
            fatGrams: 0.6,
            fatPercent: 7,
            fiberGrams: 0.6,
            fiberPercent: 8,
            gramsPerUnit: 8,
            moistureGrams: 2.5,
            moisturePercent: 31,
            proteinCalories: 12,
            proteinGrams: 3.2,
            proteinPercent: 40,
        },
        productType: 'treat',
        topSeller: false,
    },
    'chicken-jerky-treats-4oz': {
        detailsList: [
            'Made from 100% USDA certified lean chicken',
            'Preservative, antibiotic and hormone-free',
            'No artificial colors, flavors, fillers or funky stuff',
            'Gently dehydrated for the chewy texture dogs love',
            'Easy to break into pieces for training, or to use as a meal topper',
        ],
        descriptionLong: "Our premium jerky is made from 100% lean chicken and\n    nothing else, making it a naturally delicious, filler-free alternative to\n    artificially flavored biscuits and chews. Available in 4 oz packages.",
        displayName: 'Chicken Jerky',
        ingredients: 'Chicken',
        isNew: false,
        nutritionInfo: {
            caloriesPerUnit: 61,
            carbohydrateCalories: 0,
            carbohydrateGrams: 0,
            carbohydratePercent: 0,
            fatCalories: 6,
            fatGrams: 0.4,
            fatMaxGrams: 1,
            fatMaxPercent: 6.5,
            fatPercent: 2,
            fiberGrams: 1.1,
            fiberPercent: 6,
            gramsPerUnit: 19,
            moistureGrams: 3.6,
            moisturePercent: 19,
            proteinCalories: 55,
            proteinGrams: 13.3,
            proteinPercent: 70,
        },
        productType: 'treat',
        topSeller: true,
    },
    'sweet-potato-treats-6oz': {
        detailsList: [
            '100% sweet potato',
            'Low in fat + a good source of fiber',
            'No artificial colors, flavors, fillers or funky stuff',
            'A rawhide alternative',
        ],
        descriptionLong: "Made from pure sweet potatoes and nothing else, they\u2019re an\n    irresistibly chewy snack that you and your pup can both feel good about.",
        displayName: 'Sweet Potato Chews',
        ingredients: 'Sweet Potato',
        isNew: true,
        nutritionInfo: {
            caloriesPerUnit: 60,
            carbohydrateCalories: 51,
            carbohydrateGrams: 16.1,
            carbohydratePercent: 70,
            fatCalories: 3,
            fatGrams: 0.1,
            fatMaxGrams: 0.6,
            fatMaxPercent: 2.5,
            fatPercent: 0.5,
            fiberGrams: 2.8,
            fiberPercent: 12,
            gramsPerUnit: 23,
            moistureGrams: 5.8,
            moisturePercent: 25,
            proteinCalories: 6,
            proteinGrams: 0.7,
            proteinPercent: 3,
        },
        productType: 'treat',
        topSeller: false,
    },
};
var probioticInfo = {
    'probiotic-dog-full-spectrum': {
        detailsList: [
            'Expertly formulated by a veterinary nutritionist and microbiologist',
            'Helps promote a healthy microflora to support stool quality and overall digestive health',
            'Contains 20 billion CFUs and 7 full spectrum probiotic strains per serving',
            'With prebiotic fiber for added beneficial bacteria development',
            'Made with top quality ingredients at FDA registered facilities under GMP guidelines with each batch independently tested for product integrity',
        ],
        displayName: 'Full Spectrum Probiotic',
        inactiveIngredients: 'Maltodextrin',
        ingredientsList: [
            {
                ingredient: 'Lactobacillus reuteri, Pediococcus acidilactici, Enterococcus faecium, Lactobacillus acidophilus, Bifidobacterium animalis, Lactobacillus fermentum, Lactobacillus rhamnosus',
                amount: '20 billion CFUs',
            },
            { ingredient: 'Inulin', amount: '50 mg' },
        ],
        instructions: [
            {
                heading: 'Cautions',
                description: 'If animal’s condition worsens or does not improve, stop product administration and consult your veterinarian. Safe use in pregnant animals or animals intended for breeding has not been proven.',
            },
            {
                heading: 'For use in dogs only.',
                description: 'Recommended to support digestive health. Appropriate for all breeds, puppies (older than 8 weeks) to adults.',
            },
            { heading: 'Directions for Use:', description: 'Administer orally, one level scoop daily.' },
            {
                heading: 'Warnings:',
                description: 'Not for human consumption. Keep out of the reach of children and animals. In case of accidental overdose contact a health professional immediately.',
            },
            {
                heading: 'Storage and Handling:',
                description: 'Protect from light, high temperatures and moisture. Reseal after each use. Refrigerate for maximum potency.',
            },
        ],
        isNew: false,
        productType: 'probiotic',
        topSeller: false,
    },
    'probiotic-dog-gi': {
        detailsList: [
            'Expertly formulated by a veterinary nutritionist and microbiologist',
            'Helps promote a healthy microflora to support stool quality and overall digestive health',
            'Contains 20 billion CFUs and 5 probiotic strains per serving targeted specifically to manage GI issues',
            'With prebiotic fiber for added beneficial bacteria development',
            'Made with top quality ingredients at FDA registered facilities under GMP guidelines with each batch independently tested for product integrity',
        ],
        displayName: 'GI-Targeted Probiotic Support',
        inactiveIngredients: 'Maltodextrin',
        ingredientsList: [
            {
                ingredient: 'Saccharomyces boulardii, Enterococcus faecium, Bifidobacterium animalis, Lactobacillus reuteri, Pediococcus acidilactici',
                amount: '20 billion CFUs',
            },
            { ingredient: 'Inulin', amount: '50 mg' },
        ],
        instructions: [
            {
                heading: 'Cautions',
                description: 'If animal’s condition worsens or does not improve, stop product administration and consult your veterinarian. Safe use in pregnant animals or animals intended for breeding has not been proven.',
            },
            {
                heading: 'For use in dogs only.',
                description: 'Recommended to support digestive health. Appropriate for all breeds, puppies (older than 8 weeks) to adults.',
            },
            { heading: 'Directions for Use:', description: 'Administer orally, one level scoop daily.' },
            {
                heading: 'Warnings:',
                description: 'Not for human consumption. Keep out of the reach of children and animals. In case of accidental overdose contact a health professional immediately.',
            },
            {
                heading: 'Storage and Handling:',
                description: 'Protect from light, high temperatures and moisture. Reseal after each use. Refrigerate for maximum potency.',
            },
        ],
        isNew: false,
        productType: 'probiotic',
        topSeller: false,
    },
};
var addOnInfo = __assign(__assign({}, probioticInfo), treatInfo);
export { addOnInfo, treatInfo };
